import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, OnDestroy, ChangeDetectorRef, Input } from '@angular/core';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable, Subject } from 'rxjs';
import { ViewUIModel } from '../../models/view-ui.model';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { BreakpointState } from 'src/app/breakpoint/state/breakpoint.state';
import { Breakpoint } from 'src/app/breakpoint/models/breakpoint.enum';

@Component({
  selector: 'app-view-logo',
  templateUrl: './view-logo.component.html',
  styleUrls: ['./view-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewLogoComponent implements OnInit {
  @Select(ViewState.getUI)
  layout$: Observable<ViewUIModel>;

  @Select(StoryChaptersState.getSelectedChapterBackground)
  background$: Observable<BackgroundModel>;

  @Select(BreakpointState.getBreakpoint)
  breakpoint$: Observable<Breakpoint>;

  @Input()
  logoSize: 'small' | 'full' = 'full';

  @Input()
  logoColor: 'color' | 'white' = 'color';

  isLight = true;
  breakpoint = Breakpoint;
  ngUnsubscribe = new Subject();
  
  constructor(
  ) { }

  ngOnInit() {}
}
